export const SITE_ORIGIN = 'https://avisionlighting.com';
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/images/og-sky-zone-facade-lighting.jpg`;
export const DEFAULT_OG_ALT =
  'Blue and violet facade lighting on a Sky Zone entrance at night';

export function absoluteUrl(path) {
  if (!path) return SITE_ORIGIN;
  if (path.startsWith('http')) return path;
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
